import messageResource from '../messageResource'
import {USERS_WITHOUT_GROUP_ID, DEFAULT_TIME_ZONE_GROUP_ID} from '../constants'
import {stringComparator} from "../atUtils";
import GroupType from "../enums/GroupType";
import Group from '../store/Group'

export function createDefaultUserGroup() {
    return {
        id: USERS_WITHOUT_GROUP_ID,
        name: messageResource.getMessage('common.users_without_group')
    }
}

export function addDefaultUserGroup(userGroups) {
    return [createDefaultUserGroup(), ...userGroups]
}

export const createGroupComparator = (groupType) => {
    const defaultGroupId = groupType === GroupType.USER_GROUP ? USERS_WITHOUT_GROUP_ID : DEFAULT_TIME_ZONE_GROUP_ID
    return (a, b) => {
        if (a.id === b.id) return 0

        if (a.id === defaultGroupId) {
            return -1
        }
        if (b.id === defaultGroupId) {
            return 1
        }
        return stringComparator(a.name, b.name)
    }
}

export const transformListToGroups = function(listOfGroups) {
    return listOfGroups !== null ? listOfGroups.map(function(group) {
        return new Group(
            group["id"],
            group["name"],
        )
    }) : null
}



// WEBPACK FOOTER //
// ./web/js/util/groupUtils.js